export const dateToStringShort = dateIn => {
  const year = dateIn.getFullYear();
  const month = dateIn.getMonth() + 1; //Add 1 because getMonth is zero-based
  const day = dateIn.getDate();

  return `${day}.${month}.${year}`;
};

export const dateToRelativeString = dateIn => {
  const now = new Date();

  const year = dateIn.getFullYear();
  const month = dateIn.getMonth() + 1;
  const day = dateIn.getDate();

  if (
    now.getFullYear() === year &&
    now.getMonth() + 1 === month &&
    now.getDate() === day
  )
    return `Heute, ${day}.${month}.${year}`;

  return `${day}.${month}.${year}`;
};

export const dateToTimeString = dateIn => {
  const hour = dateIn.getHours();
  const minute = dateIn.getMinutes();

  return `${hour.pad(2)}:${minute.pad(2)}`;
};

Number.prototype.pad = function(size) {
  var s = String(this);
  while (s.length < (size || 2)) {
    s = "0" + s;
  }
  return s;
};



// WEBPACK FOOTER //
// ./src/utils/DateHelper.js